export default __webpack_public_path__ + "static/media/antp_ingvehicular_JoseManuel.d21e7600.jpg";